import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Directive({
  selector: '[appNumberFormat]'
})
export class NumberFormatDirective implements OnInit {

  @Input() numberFormat: string = '1.0';

  constructor(private el: ElementRef) { }

  ngOnInit(): void {
    const value = parseFloat(this.el.nativeElement.textContent);
    if(!isNaN(value)) {
      const decimalPipe = new DecimalPipe('en-US');
      const formattedValue = decimalPipe.transform(value, this.numberFormat);

      this.el.nativeElement.textContent = formattedValue;
    }
  }

}
